import ReportExample from "./report-example";

export default ReportExample;
